/**
 * Practitioner Dashboard — route under (practitioner) group.
 *
 * Re-renders the existing practitioner-manage screen content.
 * Entered via Settings > Professional section > "Open Practitioner Dashboard".
 *
 * The Stack header defined in (practitioner)/_layout.tsx provides the
 * "Practitioner Mode" indicator and back navigation to Settings.
 */

// Re-export the existing practitioner-manage screen so the route renders
// the same content without duplicating logic.
export { default } from '../(tabs)/practitioner-manage';
